import { Outlet } from 'react-router';
import { useEventListener } from 'usehooks-ts';
import BottomBar from '@/components/layouts/page-layout/bottom-bar';
import useSignOut from '@/hooks/users/use-sign-out';
import { useRootLayoutContext } from '@/routes/root.context';

export default function ProtectedLayout() {
  const { showFooter } = useRootLayoutContext();
  const { mutate: signOut } = useSignOut();

  useEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      signOut();
    }
  });

  return (
    <div className='desktop:ps-24 basis-full flex-col desktop:flex-row desktop:basis-auto flex-1 flex'>
      {showFooter && <BottomBar />}

      <Outlet />
    </div>
  );
}
